import { Component, Input } from '@angular/core';

@Component({
  selector: 'unicon-percent-indicator',
  templateUrl: './percent-indicator.component.html',
})
export class PercentIndicatorComponent {
  @Input() positive: boolean = true;
  @Input() percent?: number;
}
